var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"footer-text",domProps:{"innerHTML":_vm._s(_vm.footerText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }